import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function CopyButton({ value, label = 'Copy', iconSize = '14px' }) {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const handleCopy = async (event) => {
    // cells live inside clickable grid rows / drawer headers
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // denied permission, or an insecure context where navigator.clipboard is
      // undefined — say nothing rather than claim a copy that did not happen
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Tooltip title={copied ? 'Copied!' : label} arrow placement="top">
      <IconButton
        size="small"
        onClick={handleCopy}
        className="shrink-0 text-surface-400 hover:text-surface-600 hover:bg-surface-100"
        sx={{ padding: '4px' }}
      >
        <ContentCopyIcon sx={{ fontSize: iconSize }} />
      </IconButton>
    </Tooltip>
  );
}

export default CopyButton;
